import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { EnTetePage } from "../components/EnTetePage";
import { CarteService } from "../components/CarteService";
import { Methode } from "../components/Methode";
import { CallToAction } from "../components/CallToAction";
import { services } from "../data/mockData";

/** Page de section : tous les services, puis la méthode de travail. */
export const ServicesPage = () => (
  <>
    <EnTetePage
      chemin={[["Accueil", "/"]]}
      titre="Nos services"
      chapo="Traitement, automatisation et diffusion de données géospatiales, cartes web et développement sur mesure, sous-traitance de saisie et de collecte, formation de vos équipes."
    >
      <Link to="/#contact" className="btn-accent">
        Décrire votre besoin
        <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
      </Link>
      <Link to="/formations" className="btn-outline">
        Voir les formations
      </Link>
    </EnTetePage>

    <section className="section">
      <div className="shell">
        <h2 className="sr-only">Les six services</h2>
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {services.map((service) => (
            <CarteService key={service.slug} service={service} />
          ))}
        </div>
      </div>
    </section>

    <Methode />
    <CallToAction />
  </>
);
